import styled from 'styled-components';

export const Container = styled.div`
  background: var(--color-dark-350);
  height: 100vh;
  width: 100%;
  overflow: scroll;
`;
